import React from 'react';
import { Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory';
import BuildIcon from '@mui/icons-material/Build';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../context/AuthContext';
import { formatCurrency } from '../../../utils/formatters';

const ServicePartsTable = ({ serviceRecord }) => {
    const { currentUser } = useAuth();

    return (
        <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>Kullanılan Malzemeler / Hizmetler</Typography>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell width="50">Tip</TableCell>
                            <TableCell>Ad</TableCell>
                            <TableCell align="center" width="80">Miktar</TableCell>
                            {currentUser.role !== 'Servis Teknisyeni' && (
                                <>
                                    <TableCell align="right" width="120">Birim Fiyat</TableCell>
                                    <TableCell align="right" width="120">Toplam</TableCell>
                                </>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {serviceRecord.kullanilanParcalar?.map((item, index) => {
                            const ad = item.ad || item.aciklama || '-';
                            const miktar = item.miktar || 1;
                            const birimFiyat = item.birimFiyat || item.fiyat || 0;
                            const toplamFiyat = item.toplamFiyat || (miktar * birimFiyat);
                            const tip = item.tip || 'manual';

                            return (
                                <TableRow key={index}>
                                    <TableCell>
                                        {tip === 'urun' ? (
                                            <Chip icon={<InventoryIcon />} label="Ürün" size="small" color="primary" />
                                        ) : tip === 'hizmet' ? (
                                            <Chip icon={<BuildIcon />} label="Hizmet" size="small" color="secondary" />
                                        ) : (
                                            <Chip icon={<EditIcon />} label="Elle" size="small" />
                                        )}
                                    </TableCell>
                                    <TableCell>{ad}</TableCell>
                                    <TableCell align="center">{miktar}</TableCell>
                                    {currentUser.role !== 'Servis Teknisyeni' && (
                                        <>
                                            <TableCell align="right">
                                                {formatCurrency(birimFiyat)}
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography fontWeight="bold">
                                                    {formatCurrency(toplamFiyat)}
                                                </Typography>
                                            </TableCell>
                                        </>
                                    )}
                                </TableRow>
                            );
                        })}
                        {(!serviceRecord.kullanilanParcalar || serviceRecord.kullanilanParcalar.length === 0) && (
                            <TableRow>
                                <TableCell colSpan={currentUser.role !== 'Servis Teknisyeni' ? 5 : 3} align="center">
                                    <Typography color="text.secondary">Henüz malzeme/hizmet eklenmemiş</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default ServicePartsTable;
